
import { Button, Row } from "@nextui-org/react";
import React from "react";
import { toast, ToastContainer } from 'react-toastify';

class ConfuseButton extends React.Component {

    requesting
    token
    full_name
    handleCallBackForBranch
    constructor(props) {
        super(props);
        this.token = props.token
        this.full_name = props.full_name
        this.requesting = false
        this.handleCallBackForBranch = props.branchCallBack
    }

    docodeconfuse = () => {
        var branch = this.handleCallBackForBranch(this.full_name)
        if (branch == null) {
            return
        }
        if (this.token == null || this.token == undefined || this.requesting) {
            return
        }
        this.requesting = true
        fetch('http://162.243.171.183:8022/user/repos/codeconfuse', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                token: this.token,
                full_name: this.full_name,
                branch: branch,
            })
        })
            .then(response => response.json())
            .then(data => {
                console.log(data);
                this.requesting = false
                this.successNoti();
                this.setState({ isLoading: false });
            })
            .catch(error => {
                console.error(error);
                this.requesting = false
                this.failNoti();
                this.setState({ isLoading: false });
            });
    }

    successNoti() {
        toast.success('🦄 请求成功!', {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
        });
    }

    failNoti() {
        toast.error('🦄 请求失败!', {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
        });

    }

    toResList = ()=> {
        const w = window.open('_black')
        let url = 'http://162.243.171.183/about/' + this.full_name
        w.location.href = url
    }

    render() {
        return (<Row>
            <Button auto onPress={this.docodeconfuse}>
                混淆
            </Button>
            <Button auto onPress={this.toResList}>
                混交结果
            </Button>
        </Row>
        );
    }
}

export default ConfuseButton;